import React, { Component } from 'react';
import { Spin, Table, Tooltip, Button, Card, Icon, Input, Col, Row, Select, Modal, Typography } from 'antd';
import { openNotification } from '../../util/notificaciones';
import CatalogoRequest from '../../services/Catalogo';
import FormArticulosCiclicos from './FormArticulosCiclicos';
import { get_id } from '../../util/IdUser';
import { esBarras, getSegmento } from '../../util/generics';
import FormAgregar from './FormAgregar';
import { Diario, Semanal, TotalCiclicos } from '../../constants';
import ArticulosCiclicosRequest from '../../services/ArticulosCiclicos';
const { Title } = Typography;
const { Option } = Select;
const { confirm } = Modal

/**
 * Clase para ver el proceso de mostrar artículos
 */
export default class ArticulosCiclicos extends Component {
    state = {
        esBarra: esBarras(),
        width: window.screen.width,
        filterText: "",
        arrArticulos: [],
        noConfigurados: [],
        diarios: 0,
        semanales: 0,
        selectedRowKeys: [],
        selectedRows: [],
        filtros: {
            frecuencia: undefined,
            filtro: undefined,
            page: undefined
        },
        cargando: false,
        paginacion: {
            current: 1,
            total: 0,
        },
        modalEstatus: false,
        modalArticulos: false,
        disableDeleteFilters: true,
        disableApplyFilters: true,
        productoSelected: {
            id: null,
            idFrecuencia: null
        },
        paginaSiguiente: 1,
        arrRowsSelected: [],
        roles: localStorage.getItem("role")?.split(","),
        editAct: false
    }

    // constructor(props) {
    //     super(props);
    // }

    /**
     * Comportamiento del componente al mostrar los productos
     */
    componentDidMount = () => {
        const segmento = getSegmento()
        const esBarra = esBarras()
        if (!segmento || !esBarra) {
            let state = { ...this.state }
            const location = {
                pathname: "/",
            }
            this.setState(state, this.props.history.push(location))
        } else {
            this.buscarArticulos()
        }
    }

    buscarArticulos = () => {
        this.setState({ cargando: true }, () => {
            ArticulosCiclicosRequest.obtenerArticulosCiclicos().then(response => {
                const articulos = response.data.results
                const diarios = articulos.filter(a => a.Frecuencia === Diario)
                const semanales = articulos.filter(a => a.Frecuencia === Semanal)

                this.setState(prev => ({
                    arrArticulos: articulos,
                    diarios: diarios.length,
                    semanales: semanales.length,
                    cargando: false,
                    selectedRows: [],
                    selectedRowKeys: [],
                    arrRowsSelected: [],
                    paginacion: {
                        current: 1,
                        total: 0,
                    },
                    filtros: {
                        ...prev.filtros,
                        frecuencia: undefined
                    }
                }))
            }).catch(err => {
                this.setState({ cargando: false })
                openNotification("Ha ocurrido un error al obtener artículos cíclicos.", "Error", false)
            })
        })
    }

    // buscarNoConfigurados = () => {
    //     this.setState(({ cargando: true }), () => {
    //         ArticulosCiclicosRequest.obtenerNoConfigurados()
    //             .then(response => {
    //                 const noConfigurados = response.data.results
    //                 this.setState({ noConfigurados, cargando: false })
    //             }).catch(err => {
    //                 this.setState({ cargando: false })
    //                 openNotification("Ocurrió un error al obtener artículos sin configurar.", "Error", false)
    //             })
    //     })
    // }

    eliminarArticulo = (modo) => {
        let state = { ...this.state }
        let objEnviar = {}
        state.bloquearBotones = true;
        state.cargando = true;

        let arregloEnviar
        if (modo == 1) {
            let objEnviar = {};
            objEnviar.id = this.state.productoSelected.id
            objEnviar.frecuencia = this.state.productoSelected.idFrecuencia
            arregloEnviar = [objEnviar]
        } else {
            let arrayAux = []
            state.selectedRows.forEach(selected => {
                arrayAux.push({
                    id: selected.id,
                    frecuencia: selected.Frecuencia
                })
            });
            arregloEnviar = arrayAux
        }

        objEnviar.articulos = arregloEnviar
        this.setState(state, () => {
            ArticulosCiclicosRequest.eliminarArticuloCiclico(objEnviar)
                .then(response => {
                    state.bloquearBotones = false

                    this.setState(state, this.esconderModal(true, response.data))
                    openNotification(
                        response?.data?.cuerpo,
                        response?.data?.titulo,
                    )
                })
                .catch(err => {
                    this.setState({ bloquearBotones: false, cargando: false })
                    openNotification(
                        err?.response?.data?.cuerpo,
                        "Error",
                    )
                })
        })
    }


    /**
     * Funcion interna de ant para el manejo de los checkbox
     * 
     * @param: selectedRowKeys (la necesita ant): id de los renglones, selectedRows: toda la informacion del objeto seleccionado
     * @return: nada
     */
    onSelectChange = (selectedRowKeys, selectedRows) => {
        let flag = false;
        let rows = [...this.state.arrRowsSelected]
        if (selectedRows.length) {
            rows = rows.concat(selectedRows)
            let hash = {};
            rows = rows.filter(o => hash[o.codigo] ? false : hash[o.codigo] = true);
        }
        // selectedRows.forEach(function (artcl) {
        //     if (artcl.valores.Editable === 0)
        //         flag = true;
        // });
        this.setState({ selectedRowKeys, selectedRows, arrRowsSelected: rows, editAct: flag }, this.verifyRowsSelected);
    };

    /**
    * Funcion interna de ant para el manejo de los checkbox
    * @param: selectedRowKeys (la necesita ant): id de los renglones, selectedRows: toda la informacion del objeto seleccionado
    * @return: nada
    */
    verifyRowsSelected = () => {
        let state = { ...this.state }
        let articulos_finales = [];
        state.selectedRowKeys.forEach(item => {
            state.arrRowsSelected.forEach(obj => {
                if (obj.idArticuloInventario === item) articulos_finales.push(obj)
            })
        })
        state.selectedRows = articulos_finales;
        this.setState(state)
    }

    /**
     * BAK: Se comenta porque de momento son pocos registros y no se necesita paginación
     * por backend
     * 
     * Función que se ejecuta cuando se da clic en página siguiente
     * @param: paginaSiguiente. valor de la página siguiente
     * @return: nada. se establece un nuevo valor para la el texto a filtrar.
     */
    // handlePaginaChange = (paginaSiguiente) => {
    //     let state = { ...this.state };
    //     for (var key in state.filtros) {
    //         if (state.filtros[key] === null || state.filtros[key] === undefined) {
    //             delete state.filtros[key];
    //         }
    //     }

    //     state.paginaSiguiente = paginaSiguiente
    //     state.filtros.page = paginaSiguiente
    //     state.cargando = true
    //     let ruta = ArticulosCiclicosRequest.obtenerArticulosCiclicos(state.filtros)
    //     this.setState(state, () => {
    //         ruta.then(response => {
    //             state.paginacion.current = paginaSiguiente
    //             state.arrArticulos = response.data.results
    //             state.cargando = false
    //             this.setState(state)
    //         }).catch(err => {
    //             this.setState({ cargando: false })
    //             openNotification("Ha ocurrido un error al listar los artículos.", "Error", false)
    //         })
    //     })
    // }

    /**
     * Función que se ejecuta cuando el usuario introduce algo en la barra de búsqueda
     * @param: value. valor de la búsqueda
     * @return: nada. se establece un nuevo valor para la el texto a filtrar.
     */
    filterText = (value) => {
        let state = { ...this.state };
        let buscar = false;

        if (value.trim() !== state.filterText.trim()) buscar = true
        state.filterText = value
        state.filtros.filtro = value.trim() === "" ? undefined : value.trim()
        // state.paginaSiguiente = 1

        state.paginacion = {
            ...state.paginacion,
            current: 1,
        }

        this.setState(state);
        if (buscar) {
            clearTimeout(state.timer)
            state.timer = setTimeout(() => {
                this.filtrarBack();
            }, 1000);
        }
    }

    /**
     * Función que se encarga de hacer las peticion en el back para filtrar
     * por los siguientes valores : 
     * {empresa: int, categoria:int, 
     *  subcategoria:int estatus:bool, 
     *  categorizado:bool, 
     *  nombre/codigo:string/int
     *  }
     */
    filtrarBack = (info) => {
        let state = { ...this.state };
        for (var key in state.filtros) {
            if (state.filtros[key] === null || state.filtros[key] === undefined) {
                delete state.filtros[key];
            }
        }

        // state.filtros.page = state.paginaSiguiente;
        state.filtros.page = state.paginacion.current
        state.filtros.filtro = state.filterText.trim() === "" ? undefined : state.filterText.trim()
        state.cargando = true;

        let ruta = ArticulosCiclicosRequest.obtenerArticulosCiclicos(state.filtros)
        this.setState(state, () => {
            ruta.then(response => {
                state.arrArticulos = response.data.results
                state.cargando = false
                state.selectedRows = []
                state.selectedRowKeys = []
                state.paginacion = {
                    current: 1,
                    total: 0,
                }
                this.setState(state)
            }).catch(err => {
                this.setState({ cargando: false })
                openNotification(err?.response?.data?.cuerpo, "Error")
            })
        })
    }

    /**
     * Función para limpiar todos los filtros que han
     * sido manipulados por el usuario.
     * @param: nada
     * @return: nada
     */
    cleanFilters = () => {
        this.setState(prev => ({
            disableApplyFilters: true,
            disableDeleteFilters: true,
            filtros: {
                ...prev.filtros,
                filtro: undefined,
                frecuencia: undefined,
                page: 1,
            },
            filterText: "",
            selectedRowKeys: [],
            selectedRows: [],
            arrArticulos: [],
            paginacion: {
                current: 0,
                total: 0,
                // onChange: this.handlePaginaChange,
                pageSize: 0,
                showTitle: false
            }
        }), () => {
            this.buscarArticulos()
            openNotification("Los filtros se han limpiado correctamente.", "Éxito", true);
        })
    }

    /**
     * Función que muestra el modal de estatus
     * @param: nada.
     * @return: nada.
     */
    showModal = () => {
        this.setState({ modalEstatus: true })
    }

    /**
     * Función que esconde el modal de estatus
     * @param: value. valor para esconder el modal
     * @return: nada.
     */
    esconderModal = (value, data) => {
        let state = { ...this.state }
        if (value) {
            this.setState({
                modalEstatus: false,
                modalArticulos: false,
                selectedRows: [],
                selectedRowKeys: [],
                arrRowsSelected: [],
                productoSelected: {
                    id: null,
                    idFrecuencia: null
                },
                filterText: "",
                filtros: {
                    filtro: undefined,
                    frecuencia: undefined,
                    page: 1,
                }
            }, () => {
                this.buscarArticulos()
            })
        } else {
            this.setState({
                modalEstatus: false, modalArticulos: false, productoSelected: {
                    id: null,
                    idFrecuencia: null
                }
            })
        }

    }

    ocultarModalArticulos = () => {
        this.setState({ modalArticulos: false })
    }

    showModalArticulos = () => {
        // this.setState({ modalArticulos: true }, () => {
        //     this.buscarNoConfigurados()
        // })
        this.setState({ modalArticulos: true })
    }


    handleChangeFrecuencia = (value) => {
        if (!value) {
            this.cleanFilters();
            return;
        }

        this.setState(prev => ({
            ...prev,
            disableApplyFilters: false,
            // paginaSiguiente: 1,
            paginacion: {
                ...prev.paginacion,
                current: 1,
            },
            filtros: {
                ...prev.filtros,
                frecuencia: value
            },
        }), this.filtrarBack)
    }


    modalEliminar = (modo) => {
        const titulo = `¿Está seguro que desea eliminar ${modo === 1 ? 'el artículo seleccionado?' : 'los artículos seleccionados?'}`
        confirm({
            title: 'Confirmar',
            content: <div><b>{titulo}</b></div>,
            okText: 'Aceptar',
            cancelText: 'Cancelar',
            okButtonProps: {
                id: 'boton-aceptar-confirmacion-frecuencia-eliminar',
            },
            cancelButtonProps: {
                id: 'boton-cancelar-confirmacion-frecuencia-eliminar',
            },
            onOk: () => {
                this.setState({ cargando: true, bloquearBotones: true }, this.eliminarArticulo(modo))
            },
        });
    }

    render() {
        let columnasArticulosTemp = [
            {
                title: "Código",
                dataIndex: "codigo",
                key: "codigo",
                width: 100,
                show: true
            },
            {
                title: "Nombre",
                dataIndex: "descripcion",
                key: "descripcion",
                show: true
            },
            {
                title: "UDMA",
                dataIndex: "unidad_almacen",
                key: "unidad_almacen",
                width: 90,
                show: true
            },
            {
                title: "UDMV",
                dataIndex: "unidad_venta",
                key: "unidad_venta",
                width: 90,
                show: true
            },
            {
                title: "Frecuencia",
                dataIndex: "frecuencia",
                key: "frecuencia",
                width: 90,
                show: true,
                render: (_, record) => (
                    <>
                        {record.Frecuencia === Diario ? 'Diario' : 'Semanal'}
                    </>
                )
            },
            {
                title: 'Acciones',
                dataIndex: 'Acciones',
                key: 'Acciones',
                width: 100,
                show: true,
                render: (value, record) => (
                    <div >
                        {
                            <>
                                <span style={{ marginRight: 5 }}>
                                    <Tooltip placement="top" title={"Editar artículo"}>
                                        <Button
                                            id="boton-editar-frecuencia-producto-form"
                                            icon="edit"
                                            className="btnEditar"
                                            onClick={() => {
                                                this.setState({
                                                    productoSelected: {
                                                        id: record.id,
                                                        idFrecuencia: record.Frecuencia
                                                    },
                                                    modo: "uno",
                                                }, this.showModal())
                                            }}
                                        >
                                        </Button>
                                    </Tooltip>
                                </span>

                                <span style={{ marginRight: 5 }}>
                                    <Tooltip placement="top" title={"Eliminar artículo"}>
                                        <Button
                                            id="boton-eliminar-frecuencia-producto-form"
                                            icon="delete"
                                            className="btnEliminar"
                                            onClick={() => {
                                                this.setState({
                                                    productoSelected: {
                                                        id: record.id,
                                                        idFrecuencia: record.Frecuencia
                                                    }
                                                })
                                                this.modalEliminar(1)
                                            }}
                                        >
                                        </Button>
                                    </Tooltip>
                                </span>
                            </>
                        }

                    </div>
                )
            }
        ]
        let columnasArticulos = columnasArticulosTemp.filter(obj => obj.show === true)
        const { selectedRowKeys } = this.state;
        const rowSelection = {
            selectedRowKeys,
            onChange: this.onSelectChange,
            hideDefaultSelections: true,
            selections: [
                {
                    key: 'all-data',
                    text: 'Seleccionar todo',
                    onSelect: () => {
                        this.setState({
                            selectedRowKeys: this.state.arrArticulos.map(item => item.idArticuloInventario),
                            selectedRows: [...this.state.arrArticulos]
                        });
                    },
                },
                {
                    key: 'un-select-all',
                    text: 'Deseleccionar todo',
                    onSelect: changableRowKeys => {
                        this.setState({ selectedRowKeys: [], selectedRows: [] });
                    },
                },
            ],
        };

        return (
            <Card id="ParentSize"
                title="Artículos cíclicos"
                extra={
                    <div>
                        <Row gutter={24}>
                            {/* <Col span={18} style={{ backgroundColor: 'rgba(0, 255, 236, 0.2)', fontSize: "14px", fontWeight: "bold" }}>
                                <p>
                                    <Icon type="exclamation-circle" style={{ color: 'rgb(253, 135, 0)' }} /> &nbsp;
                                    {`No se guardará la configuración de Artículos para ${this.state.esBarra ? 'una barra' : 'un Drive'} si cuenta con un inventario no Finalizado el día de hoy.`}
                                </p>
                            </Col> */}

                            <Col span={12}>
                                <Button
                                    id="boton-agregar-productos-ciclicos"
                                    type={"primary"}
                                    // style={{ width: '80%', marginLeft: '2.5%', marginBottom: "30px", marginTop: '1.7em' }}
                                    disabled={this.state.cargando || this.state.selectedRowKeys.length}
                                    onClick={() => {
                                        this.showModalArticulos()
                                    }}
                                >
                                    Agregar artículos
                                </Button>
                            </Col>
                            <Col span={12}>
                                <Button
                                    type="danger"
                                    id="boton-editar-estatus-articulos"
                                    disabled={!this.state.selectedRowKeys.length}
                                    onClick={() => this.modalEliminar(2)}
                                >
                                    Eliminar artículos
                                </Button>
                            </Col>
                        </Row>
                    </div>
                }
            >

                <div className="panel-block">
                    <div style={{ marginBottom: "20px" }}>
                        <Row gutter={24}>
                            <Col lg={12} md={10} sm={10} xs={10}>
                                <div className="center">Frecuencia:</div>
                                <Tooltip
                                    placement="top"
                                    title="Seleccione frecuencia">
                                    <Select
                                        id="select-drive-calendario-modulo"
                                        showSearch
                                        style={{ width: "100%" }}
                                        defaultActiveFirstOption={false}
                                        notFoundContent='No hay opciones'
                                        placeholder="Seleccionar..."
                                        optionFilterProp="children"
                                        onChange={this.handleChangeFrecuencia}
                                        value={this.state.filtros.frecuencia}
                                        allowClear
                                    >
                                        <Option value={null} disabled={true}>Seleccionar...</Option>
                                        <Option
                                            key={1}
                                            value={1}>
                                            Diario
                                        </Option>
                                        <Option
                                            key={2}
                                            value={2}>
                                            Semanal
                                        </Option>
                                    </Select>
                                </Tooltip>
                            </Col>
                            {/* <Col lg={2} md={4} sm={4} xs={4}>
                                <Tooltip placement="top" title="Buscar artículos">
                                    <Button
                                        id="boton-buscar-productos-ciclicos"
                                        className={this.state.disableApplyFilters ? "disableBtn" : ""}
                                        icon='search'
                                        type={this.state.disableApplyFilters ? "default" : "primary"}
                                        style={{ width: '80%', marginLeft: '2.5%', marginBottom: "30px", marginTop: '1.7em' }}
                                        onClick={() => {
                                            this.setState({ paginaSiguiente: 1 }, this.filtrarBack)
                                        }}
                                    >
                                    </Button>
                                </Tooltip>
                            </Col> */}
                            {/* <Col span={6} offset={6}>
                                <Button
                                    id="boton-agregar-productos-ciclicos"
                                    type={"primary"}
                                    style={{ width: '80%', marginLeft: '2.5%', marginBottom: "30px", marginTop: '1.7em' }}
                                    disabled={this.state.cargando}
                                    onClick={() => {
                                        this.showModalArticulos()
                                    }}
                                >
                                    Agregar artículos
                                </Button>
                            </Col> */}

                        </Row>
                        <Row gutter={24} style={{ display: 'flex', alignItems: 'center', marginTop: '20px' }}>
                            <Col span={8}>
                                <div className="center">Búsqueda:</div>
                                <Tooltip
                                    placement="top"
                                    title="Buscar por Código / Nombre ">
                                    <Input
                                        maxLength={50}
                                        id="input-buscar-articulos-tabla-productos"
                                        placeholder="Buscar por Código / Nombre"
                                        prefix={<Icon type='search' />}
                                        onChange={(e) => this.filterText(e.currentTarget.value)}
                                        value={this.state.filterText}
                                        disabled={!this.state.filtros.frecuencia}
                                    />
                                </Tooltip>
                            </Col>

                            <Col offset={this.state.width > 800 ? 4 : 2} span={this.state.width > 800 ? 6 : 8}>
                                <Title level={4}>Diarios: {`${this.state.diarios}/${TotalCiclicos}`}</Title>
                            </Col>
                            <Col span={this.state.width > 800 ? 6 : 8} >
                                <Title level={4}>Semanales: {`${this.state.semanales}/${TotalCiclicos}`}</Title>
                            </Col>
                        </Row>
                    </div>

                    <Spin
                        tip="Cargando..."
                        indicator={<Icon type="loading" style={{ fontSize: 24, color: "#e0cbae" }} spin />}
                        spinning={this.state.cargando}
                        style={{ color: "#e0cbae", backgroundColor: "rgb(255,255,255,0.8)" }}>
                        <div style={{ height: '500px' }}>
                            <Table size="small"
                                locale={{ emptyText: 'No se han encontrado resultados' }}
                                rowKey={articulo => articulo.idArticuloInventario}
                                columns={columnasArticulos}
                                dataSource={this.state.arrArticulos}
                                rowSelection={rowSelection}
                                scroll={{ y: 450 }}
                                // pagination={{
                                //     ...this.state.paginacion,
                                //     onChange: (page, pageSize) => {
                                //         const tabla = document.querySelector('.ant-table-body');
                                //         if (tabla) {
                                //             tabla.scrollTop = 0;
                                //         }
                                //     }
                                // }}

                                pagination={{
                                    ...this.state.paginacion,
                                    onChange: (page, pageSize) => {
                                        const tabla = document.querySelector('.ant-table-body');
                                        if (tabla) {
                                            tabla.scrollTop = 0;
                                        }
                                        this.setState(prev => ({
                                            paginacion: {
                                                ...prev.paginacion,
                                                current: page,
                                            },
                                        }));
                                    }
                                }}
                            />
                        </div>
                    </Spin>
                </div>
                <FormArticulosCiclicos
                    esconderModal={this.esconderModal}
                    visible={this.state.modalEstatus}
                    modo={this.state.modo}
                    producto_selected={this.state.productoSelected}
                    diarios={this.state.diarios}
                    semanales={this.state.semanales}
                />
                <FormAgregar
                    noConfigurados={this.state.noConfigurados}
                    esconderModal={this.esconderModal}
                    visible={this.state.modalArticulos}
                    diarios={this.state.diarios}
                    semanales={this.state.semanales}
                />
            </Card>
        )
    }
}